import { Y42FeatureType } from '@y42/json-schema';
import { Y42GitFolder, Y42GitFolders } from './wasm-git-folders.model';

export const Y42FeatureToGitFolder: Record<`${Y42FeatureType}`, Y42GitFolders> = {
  [Y42FeatureType.Integration]: Y42GitFolders.Integration,
  [Y42FeatureType.UiModel]: Y42GitFolders.UiModel,
  [Y42FeatureType.SqlModel]: Y42GitFolders.SqlModel,
  [Y42FeatureType.Orchestration]: Y42GitFolders.Orchestration,
  [Y42FeatureType.VisualizationDashboard]: Y42GitFolders.VisualizationDashboard,
  [Y42FeatureType.VisualizationWidget]: Y42GitFolders.VisualizationWidget,
  [Y42FeatureType.VisualizationTheme]: Y42GitFolders.VisualizationTheme,
  [Y42FeatureType.VisualizationFilter]: Y42GitFolders.VisualizationFilter,
  [Y42FeatureType.Export]: Y42GitFolders.Export,
  [Y42FeatureType.StatusAlert]: Y42GitFolders.AlertStatusAlert,
  [Y42FeatureType.Lineage]: Y42GitFolders.Lineage,
  [Y42FeatureType.Catalog]: Y42GitFolders.Catalog,
};

export const Y42GitFolderToFeature: Record<Y42GitFolder, `${Y42FeatureType}`> = {
  [Y42GitFolders.Integration]: Y42FeatureType.Integration,
  [Y42GitFolders.Model]: Y42FeatureType.UiModel,
  [Y42GitFolders.UiModel]: Y42FeatureType.UiModel,
  [Y42GitFolders.SqlModel]: Y42FeatureType.SqlModel,
  [Y42GitFolders.Orchestration]: Y42FeatureType.Orchestration,
  [Y42GitFolders.Visualization]: Y42FeatureType.VisualizationDashboard,
  [Y42GitFolders.VisualizationDashboard]: Y42FeatureType.VisualizationDashboard,
  [Y42GitFolders.VisualizationWidget]: Y42FeatureType.VisualizationWidget,
  [Y42GitFolders.VisualizationTheme]: Y42FeatureType.VisualizationTheme,
  [Y42GitFolders.VisualizationFilter]: Y42FeatureType.VisualizationFilter,
  [Y42GitFolders.Export]: Y42FeatureType.Export,
  [Y42GitFolders.Alert]: Y42FeatureType.StatusAlert,
  [Y42GitFolders.AlertStatusAlert]: Y42FeatureType.StatusAlert,
  [Y42GitFolders.Lineage]: Y42FeatureType.Lineage,
  [Y42GitFolders.Catalog]: Y42FeatureType.Catalog,
};
